import {useEffect} from 'react';
import {createFileRoute, redirect, useNavigate} from '@tanstack/react-router';

import {useAuthStore} from '@/store/auth';
import {useAuth} from '@/hooks/useAuth';
import {LoginPage} from '@/modules/auth/pages/LoginPage';

interface LoginSearch {
  session_expired?: boolean;
}

const validateLoginSearch = (search: Record<string, unknown>): LoginSearch => ({
  session_expired: search.session_expired === 'true' || search.session_expired === true,
});

export const Route = createFileRoute('/login')({
  validateSearch: validateLoginSearch,
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({to: '/'});
    }
  },
  component: LoginGuard,
});

function LoginGuard() {
  const {isAuthenticated, isLoading} = useAuth();
  const {session_expired} = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // replace: true — `/login` is not a place an authenticated user should
      // be able to back-button to.
      void navigate({to: '/', replace: true});
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (!isLoading && isAuthenticated) {
    return null;
  }

  return <LoginPage sessionExpired={session_expired} />;
}
